import React from 'react';
import { Waypoint } from 'react-waypoint';
import { ShowroomCategoryV3 } from '../../store';
import { VehicleCardV3 } from '../vehicle-card';
import styles from './index.module.scss';

interface Props {
  category: ShowroomCategoryV3;
  backgroundColor: string;
  onViewEnter: (selector: string) => void;
}

export const VehicleCategoryV3 = React.memo(
  React.forwardRef<HTMLDivElement, Props>(
    ({ category, backgroundColor, onViewEnter }, ref) => {
      const handleViewEnter = () => {
        onViewEnter(category.categorySelector);
      };

      const getCardSize = (index: number) => {
        const isLast = index === category.showroomModels.length - 1;
        const isOddCount = category.showroomModels.length % 2 !== 0;
        return isLast && isOddCount ? 'full' : 'half';
      };

      return (
        <Waypoint topOffset={200} bottomOffset={500} onEnter={handleViewEnter}>
          <div
            ref={ref}
            id={category.categorySelector}
            className={styles.vehicleCategory}
            style={{ backgroundColor }}
          >
            <div className="container">
              <h2
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: category.categoryTitle }}
              />

              {category.categoryDescription && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: category.categoryDescription,
                  }}
                />
              )}

              {category.learnMore && category.learnMore.length > 0 && (
                <div className={styles.ctaGroup}>
                  {category.learnMore.map((link, idx) => (
                    <a
                      key={idx}
                      href={link.url}
                      target={link.target || '_self'}
                      className={styles.ctaBtn}
                    >
                      {link.name}
                    </a>
                  ))}
                </div>
              )}

              <div className={styles.grid}>
                {(category.showroomModels || []).map((model, index) => (
                  <VehicleCardV3
                    key={model.id}
                    model={model}
                    size={getCardSize(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </Waypoint>
      );
    }
  )
);
